import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

import { FlexGrid } from "../../common/grid/components/FlexGrid";
import Button from "../../common/button/components/Button";
import {
  BoxButton,
  MiniBoxPrice,
  Observation,
  PriceBoxText,
} from "../../home/components/Products/styles/ProductsStyles";
import type { ProductDefinition } from "../types/productTypes";

type ProductPricePanelProps = {
  product: ProductDefinition;
  onContract: () => void;
};

export const ProductPricePanel = ({
  product,
  onContract,
}: ProductPricePanelProps) => {
  return (
    <Grid size={{ xs: 12, sm: 12, md: 2.5 }} marginTop={{ xs: 2, sm: 2, md: 0 }}>
      <Grid container>
        {product.price ? (
          <FlexGrid
            flexDirection="column"
            alignItems="center"
            size={{ xs: 12 }}
          >
            <Grid size={{ xs: 12 }}>
              <MiniBoxPrice>
                R$ <span>{product.price}</span>,{product.decimalPrice}*
              </MiniBoxPrice>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <PriceBoxText>mensais por pessoa</PriceBoxText>
            </Grid>
          </FlexGrid>
        ) : (
          <Skeleton width="100%" />
        )}

        <Grid size={{ xs: 12 }} marginBottom={0.5} justifyContent="center">
          <BoxButton>
            <Button
              type="button"
              variant="contained"
              $background="fill"
              $width="232px"
              $bgcolor="#FF5000"
              onClick={onContract}
            >
              Contrate Já
            </Button>
          </BoxButton>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Observation>
            *Acréscimo de IOF{" "}
            {product.iof !== null && product.iof !== undefined ? (
              `(${product.iof.toFixed(2).replace(".", ",")}%)`
            ) : (
              <Skeleton sx={{ display: "inline-flex", width: "40px" }} />
            )}
          </Observation>
        </Grid>
      </Grid>
    </Grid>
  );
};